export default __webpack_public_path__ + "static/media/stage2_documents_4.dbaf541f.jpg";